import { all } from "redux-saga/effects";
import user from "./user";
import cart from "./cart";

const sagas = function* sagas() {
  yield all([user(), cart()]);
};

export default sagas;
